<template>
  <v-layout style="width: fit-content; height: 100%" align-center>
    <div class="home-footer-info ml-1" id="current-workspace-text">
      {{ $tc("Workspace", 1) + ": " + activeWorkspace }}
    </div>
  </v-layout>
</template>

<script>
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "HomeFooterActiveWorkspace",

  mixins: [checkPermissionsMixin],

  computed: {
    activeWorkspace() {
      return this.$store.getters.workspace.label;
    }
  }
};
</script>

<style scoped>
#current-workspace-text {
  white-space: nowrap;
  text-overflow: ellipsis;
  align-items: initial;
  font-size: 11px;
  padding-right: 10px;
  padding-top: 0;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Footer/ActiveWorkspace.vue